import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateRangeSelector.css';

const parseLocalDate = (str) => { if (!str) return null; const [y,m,d] = str.split('-').map(Number); return new Date(y, m-1, d); };
const dateToStr = (date) => { if (!date) return ''; const y=date.getFullYear(),m=String(date.getMonth()+1).padStart(2,'0'),d=String(date.getDate()).padStart(2,'0'); return `${y}-${m}-${d}`; };

function DateRangeSelector({ startDate, endDate, onDateRangeChange }) {
const [selectedStartDate, setSelectedStartDate] = useState(
    startDate.toISOString().split('T')[0]
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    endDate.toISOString().split('T')[0]
  );

  const [activePreset, setActivePreset] = useState(null);

  const handleApply = () => {
    const newStartDate = new Date(selectedStartDate);
    const newEndDate = new Date(selectedEndDate);

    if (newEndDate > new Date()) {
      alert("End date cannot be in the future");
      return;
    }
    if (newStartDate > newEndDate) {
      alert("Start date cannot be after end date");
      return;
    }

    onDateRangeChange(newStartDate, newEndDate);
    setActivePreset(null);
  };

  const handlePreset = (days) => {
    const newEndDate = new Date();
    const newStartDate = new Date();
    newStartDate.setDate(newEndDate.getDate() - days);

    setSelectedStartDate(newStartDate.toISOString().split('T')[0]);
    setSelectedEndDate(newEndDate.toISOString().split('T')[0]);
    onDateRangeChange(newStartDate, newEndDate);

     setActivePreset(days);
  };

  return (
    <div className="date-range-selector">
      <div className="date-inputs">
        <div className="form-group input-group">
          <label className='form-label'>Start Date</label>
          <DatePicker
            selected={parseLocalDate(selectedStartDate)}
            onChange={(date) => setSelectedStartDate(dateToStr(date))}
            maxDate={parseLocalDate(selectedEndDate) || new Date()}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select start date"
            className="form-control form-inputbox"
            wrapperClassName="drs-picker-wrap"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            popperPlacement="bottom-start"
            popperClassName="li-datepicker-popper"
            popperProps={{ strategy: 'fixed' }}
            autoComplete="off"
          />
        </div>

        <div className="form-group input-group">
          <label className='form-label'>End Date</label>
          <DatePicker
            selected={parseLocalDate(selectedEndDate)}
            onChange={(date) => setSelectedEndDate(dateToStr(date))}
            minDate={parseLocalDate(selectedStartDate) || undefined}
            maxDate={new Date()}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select end date"
            className="form-control form-inputbox"
            wrapperClassName="drs-picker-wrap"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            popperPlacement="bottom-start"
            popperClassName="li-datepicker-popper"
            popperProps={{ strategy: 'fixed' }}
            autoComplete="off"
          />
        </div>

        <div className="form-group input-group">
          <button className="btn btn-primary" onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>

      <div className="preset-buttons buttons-group">
        <button className={`report-btn ${activePreset === 7 ? 'active' : ''}`} onClick={() => handlePreset(7)}>
           <svg  xmlns="http://www.w3.org/2000/svg" 
            width="14" height="14" 
            viewBox="0 0 24 24" 
            fill="currentColor" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            class="lucide lucide-circle-check-icon tick-icon">
          <circle cx="12" cy="12" r="10" fill="currentColor"/>
          <path d="M7 12 L11 16 L17 9" stroke="currentColor" stroke-width="2"/>
        </svg>

          Last 7 Days
        </button>
        <button className={`report-btn ${activePreset === 30 ? 'active' : ''}`} onClick={() => handlePreset(30)}>
           <svg  xmlns="http://www.w3.org/2000/svg" 
            width="14" height="14" 
            viewBox="0 0 24 24" 
            fill="currentColor" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            class="lucide lucide-circle-check-icon tick-icon">
          <circle cx="12" cy="12" r="10" fill="currentColor"/>
          <path d="M7 12 L11 16 L17 9" stroke="currentColor" stroke-width="2"/>
        </svg> 

          Last 30 Days
        </button>
        <button className={`report-btn ${activePreset === 90 ? 'active' : ''}`} onClick={() => handlePreset(90)}>
         <svg  xmlns="http://www.w3.org/2000/svg" 
            width="14" height="14" 
            viewBox="0 0 24 24" 
            fill="currentColor" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            class="lucide lucide-circle-check-icon tick-icon">
          <circle cx="12" cy="12" r="10" fill="currentColor"/>
          <path d="M7 12 L11 16 L17 9" stroke="currentColor" stroke-width="2"/>
        </svg> 

          Last 90 Days
        </button>
      </div>
    </div>
  );
}

export default DateRangeSelector;
